module.exports = __webpack_public_path__ + "media/images/tennis-a017d2ef.jpg";